import React from "react";
import { isArray, isString } from "lodash";
import { _getBaseUrl, _capitalized, _getTranslation } from "../utils/helper";

const CardMediaExpert = ({ data, ...props }) => {
  const imageURL =
    data.image ||
    _getBaseUrl("src/assets/profile-picture-placeholder.png", true);
  const skillKeys = ["location", "expertise", "languages"];

  const ProfileNameAndPosition = ({ classes }) => (
    <div className={classes ? classes : ""}>
      <div className="font-semibold text-mobileM md:text-desktopM">
        {data.name}
      </div>

      {data.position && (
        <div className="text-mobileS md:text-desktopS mb-2">
          {data.position}
        </div>
      )}
    </div>
  );

  return (
    <div className="card--expert flex flex-col sm:flex-row gap-y-4 gap-x-8 items-start">
      <div className="flex items-center gap-5">
        <div className="flex-shrink-0 w-[100px] sm:w-[140px] aspect-[14/18] rounded-md overflow-hidden bg-gray-300 relative">
          <img
            src={imageURL}
            alt={data.image_alt}
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
        <ProfileNameAndPosition classes="flex-grow sm:hidden" />
      </div>
      <div className="flex-grow">
        <ProfileNameAndPosition classes="hidden sm:block" />
        <div className="text-mobileS md:text-desktopS xl:w-10/12">
          {skillKeys.map(
            (keyName) =>
              data.hasOwnProperty(keyName) && (
                <div className="grid grid-cols-3 sm:grid-cols-5 gap-y-2">
                  <div className="font-bold col-span-1 sm:col-span-2 lg:col-span-1">
                    {_capitalized(_getTranslation(keyName))}
                  </div>
                  <div className="col-span-2 sm:col-span-3 lg:col-span-4">
                    {isArray(data[keyName])
                      ? data[keyName].join(", ")
                      : isString(data[keyName])
                      ? data[keyName]
                      : null}
                  </div>
                </div>
              )
          )}
        </div>

        <a
          href={data.permalink}
          className="tema-text--link---arrow mt-5 mr-8"
          // target="_blank"
        >
          {_getTranslation("view_profile")}
        </a>

        {data.profilePictures && (
          <a
            href={data.profilePictures}
            className="tema-text--link---arrow mt-5"
            target="_blank"
          >
            {_getTranslation("download_profile_pictures")}
          </a>
        )}
      </div>
    </div>
  );
};

export default CardMediaExpert;
